<template>
	<section id="selfdxPanroTv" class="selfdx-section display-flex" :class="{ 'is-active': isVisible }" ref="viewport">
		<div class="selfdx-bg">
			<i class="icon icon-selfdx-bg4"></i>
		</div>
		<div class="container">
			<div class="selfdx-section-header">
				<h3 class="selfdx-section-header__title">영상으로 배우는 <span class="color-orange">판로정보</span></h3>
				<p class="selfdx-section-header__desc">
					각 분야 전문가들이 들려주는 판로정보부터 지원사업 성공사례까지,<br />
					다양한 영상 콘텐츠를 통해 온라인 진출에 도전해 보세요.
				</p>
				<div class="selfdx-section-header__buttons">
					<a href="/broadcast" target="_blank" class="button-default is-medium is-rounded is-secondary">전체 판로TV 보기</a>
				</div>
			</div>
			<div class="selfdx-section-content">
				<ul class="card-list">
					<li v-for="(item, idx) in diagnFanroVods.slice(0, 2)" :key="idx">
						<broadcast-card type="20" :vodLink="item.vodLink" :img="item.vodThumbnail" :alt="item.vodTitle" :subDesc="item.vodTitle" :isOpenTab="true" />
					</li>
				</ul>
			</div>
		</div>
	</section>
</template>

<script>
import BroadcastCard from '@/components/broadcast/BroadcastCard';
export default {
	name: 'SelfDxResultPanrotv',
	components: { BroadcastCard },
	props: {
		diagnFanroVods: {
			type: Array,
			default: [],
		},
	},
	data: () => ({
		isVisible: false,
	}),
	mounted() {
		this.$nextTick(() => {
			this.initializeIntrsObsrv();
		});
	},
	methods: {
		initializeIntrsObsrv() {
			const io = new IntersectionObserver(
				(entries, observer) => {
					entries.forEach(async (entry) => {
						// 감지대상이 교차영역에 진입 할 경우
						if (entry.isIntersecting) {
							this.isVisible = true;
							// 교차영역에 진입한 후 감지대상을 관찰 중지
							observer.unobserve(entry.target);
						} else {
							this.isVisible = false;
						}
					});
				},
				{
					rootMargin: '0px',
					threshold: 0.1,
				}
			);
			const element = this.$refs.viewport;
			if (element) {
				io.observe(element);
			}
		},
	},
};
</script>
